import readOnlyTools from "./readOnly";
import proposeTools from "./propose";
import metaTools from "./meta";
import formControlTools from "./formControl";
import collectorScriptTools from "./collectorScript";
import confirmTools from "./confirm";
import analyticsTools from "./analytics";
import skillTools from "./skills";

// run_skill is deliberately NOT in this static list — its schema must
// enumerate the live skill index, rebuilt fresh each turn. See
// tools/skills.js's buildRunSkillTool and turn.js for where it's spliced in.
const allTools = [
  ...readOnlyTools,
  ...proposeTools,
  ...metaTools,
  ...formControlTools,
  ...collectorScriptTools,
  ...confirmTools,
  ...analyticsTools,
  ...skillTools,
];

export default allTools;
